/**
 * Card photos (`shared/ui/blur-up-image.tsx`) start hidden and soft, then fade
 * in sharp once their file has loaded. Waiting for React's onLoad meant a
 * photo that had already arrived stayed invisible until the page's JS had
 * started, about 2 s on a phone (Lighthouse, 2026-11-02). Instead this inline
 * script, run in <head> before any photo is parsed, marks each one
 * `data-loaded` from the browser's own load event, and CSS in
 * `lib/tailwind.css` does the fade. Load events do not bubble, so it listens
 * in the capture phase.
 */
export const BLUR_UP_CLASS = "mj-blur-up";

/** Skips the fade for a photo that was already in the browser's cache. */
export const BLUR_UP_INSTANT_CLASS = "mj-blur-up-instant";

/** Inline <script> for `routes/__root.tsx`, kept here so it can be tested. */
export const BLUR_UP_SCRIPT = `document.addEventListener('load',function(e){var t=e.target;if(t&&t.classList&&t.classList.contains('${BLUR_UP_CLASS}'))t.setAttribute('data-loaded','');},true);`;
